import React from 'react';
import AgentDashboard from './AgentDashboard';

const HRPolicyDashboard: React.FC = () => {
  const agentConfig = {
    id: 'hrpolicy',
    displayName: 'PolicyTech',
    icon: '/assets/logos/aldo-hr-policy.png',
    color: '#8b5cf6',
    description: 'HR policies, procedures, and employee guidance',
    hasTestResults: true
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default HRPolicyDashboard;